export abstract class RoutePaths {
  static readonly Forbidden = 'errors/403';
  static readonly NotFound = 'errors/404';
}
